
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ContentSliderComponent } from '../components/content-slider/content-slider.component';

// --- Shared Components (Declarations & Exports) ---
import { AppButtonComponent } from '../components/app-button/app-button.component';
import { MySubscriptionCardComponent } from '../components/my-subscription-card/my-subscription-card.component';
import { MenuItemComponent } from '../components/menu-item/menu-item.component';
import { MacrosBarComponent } from '../components/marcos-bar/macros-bar.component';
import { PopupModalComponent } from '../components/popup-modal/popup-modal.component';
import { AppSliderComponent } from '../components/app-slider/app-slider.component';
import { AppStatComponent } from '../components/app-stat/app-stat.component';
import { AppRatingComponent } from '../components/app-rating/app-rating.component';
import { AppInputComponent } from '../components/app-input/app-input.component';
import { AppHeaderComponent } from '../components/app-header/app-header.component';
import { GeneralModalComponent } from '../components/general-modal/general-modal.component';
import { SignUpComponent } from '../components/signup-form/signup.component';
import { SignInComponent } from '../components/signin-form/signin.component';
import { SlideBarComponent } from '../components/slide-bar/slide-bar.component';
import { NutritionCardComponent } from '../components/nutrition-card/nutrition-card.component';
import { PaymentModalComponent } from '../components/payment-modal/payment-modal.component';

// --- Shared Pages (Declarations & Exports) ---
// Note: Pages/Containers are typically only declared if they are modal/popovers used across features.
import { CommentModalPage } from '../community/comment-modal/comment-modal.page';
import { PostModalPage } from '../community/post-modal/post-modal.page';
import { AreaListsPage } from '../pages/area-lists/area-lists.page';
import { TermsAndConditionsPage } from '../pages/terms-and-conditions/terms-and-conditions.page';
import { EditAddressPage } from '../pages/edit-address/edit-address.page';
import { RatingPage } from '../calendar/rating/rating.page';
import { SelectionPage } from '../calendar/selection/selection.page';
import { AboutusPage } from '../pages/aboutus/aboutus.page';

@NgModule({
  declarations: [
    NutritionCardComponent,
    SlideBarComponent,
    GeneralModalComponent,
    AboutusPage,
    MySubscriptionCardComponent,
    AppHeaderComponent,
    RatingPage,
    SelectionPage,
    CommentModalPage,
    PostModalPage,
    EditAddressPage,
    AreaListsPage,
    TermsAndConditionsPage,
    AppInputComponent,
    AppRatingComponent,
    AppStatComponent,
    PopupModalComponent,
    AppSliderComponent,
    AppButtonComponent,
    MenuItemComponent,
    MacrosBarComponent,
    SignUpComponent,
    SignInComponent,
    PaymentModalComponent,
    ContentSliderComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule
  ],
  exports: [
    // Base Angular Modules (for use in feature modules)
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,

    // Shared Components and Pages
    NutritionCardComponent,
    SlideBarComponent,
    SignUpComponent,
    SignInComponent,
    GeneralModalComponent,
    AboutusPage,
    MySubscriptionCardComponent,
    AppHeaderComponent,
    RatingPage,
    SelectionPage,
    CommentModalPage,
    PostModalPage,
    EditAddressPage,
    AreaListsPage,
    TermsAndConditionsPage,
    AppInputComponent,
    AppRatingComponent,
    AppStatComponent,
    PopupModalComponent,
    AppSliderComponent,
    AppButtonComponent,
    MenuItemComponent,
    MacrosBarComponent,
    PaymentModalComponent,
    ContentSliderComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}